enum BIFlowType {

    PropPopup = "popup",
    PropMultistep = "multistep"
}

export {
    BIFlowType
};
